import { Link } from "@tanstack/react-router";
import { useState } from "react";
import avatar from "assets/img/avatar.png";
import { Button } from "components/elements";
import {
    ClientFriendRequest,
    ClientUser,
    Friend,
    FriendRequestStatus,
} from "@compass/shared/types";
import { DeclineModal } from "./DeclineModal";
import { NoFriendRequests } from "./NoFriendRequests";

type FriendRequestsProps = {
    requests?: ClientFriendRequest;
    onFriendRequestResponse: ({ id, status }: { id: number; status: FriendRequestStatus }) => void;
    setModalOpen: (isOpen: boolean) => void;
};

export const FriendRequests = ({
    requests,
    onFriendRequestResponse,
    setModalOpen,
}: FriendRequestsProps) => {
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [selectedFriend, setSelectedFriend] = useState<any | null>(null);

    return (
        <>
            {requests?.length === 0 ? (
                <NoFriendRequests setModalOpen={setModalOpen} />
            ) : (
                <div className="flex h-4/6 w-full items-start justify-center">
                    <div className="grid w-full grid-cols-2 gap-4">
                        {requests?.map((friend) => (
                            <div
                                key={friend.id}
                                className="h-30 bg-brand-polar rounded-2xl border border-[#c8c8c8] p-4"
                            >
                                <div className="flex w-full items-start justify-between gap-4">
                                    <div className="flex items-start gap-4">
                                        <Link
                                            to="/profile/$id"
                                            target="_blank"
                                            params={{ id: `${friend.sender?.[0]?.id}` }}
                                            className="text-inherit no-underline focus:outline-none focus:ring-0"
                                        >
                                            <img
                                                src={friend.sender?.[0]?.avatarUrl || avatar}
                                                alt={friend.sender?.[0]?.name ?? "Unknown"}
                                                className="h-12 w-12 rounded-md bg-[#def1fa]"
                                            />
                                        </Link>
                                        <div className="flex flex-col">
                                            <Link
                                                to="/profile/$id"
                                                target="_blank"
                                                params={{ id: `${friend.sender?.[0]?.id}` }}
                                                className=" text-inherit no-underline focus:outline-none focus:ring-0"
                                            >
                                                <div className="cursor-pointer font-semibold">
                                                    {friend.sender?.[0]?.name ?? "Unknown"}
                                                </div>
                                            </Link>
                                            <div className="text-sm font-semibold">
                                                2 Mutual friends
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-row gap-2 self-center">
                                        <Button
                                            onClick={() => {
                                                onFriendRequestResponse({
                                                    id: friend.id,
                                                    status: "ACCEPTED",
                                                });
                                            }}
                                            size="smaller"
                                            variant="primary"
                                        >
                                            Confirm
                                        </Button>
                                        <Button
                                            onClick={() => {
                                                setSelectedFriend(friend);
                                                setShowDeclineModal(true);
                                            }}
                                            size="smaller"
                                            variant="secondary"
                                        >
                                            Decline
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {selectedFriend && (
                <DeclineModal
                    isOpen={showDeclineModal}
                    setIsOpen={setShowDeclineModal}
                    userId={selectedFriend.id}
                    userName={selectedFriend.sender?.[0]?.firstName}
                    onDecline={onFriendRequestResponse}
                />
            )}
        </>
    );
};
